import { Instagram, MessageCircle, ArrowUpRight } from "lucide-react";
import { INSTAGRAM_URL, LOGO_URL, WHATSAPP_URL, buildWhatsAppLink } from "../lib/i18n";

export const Footer = ({ t, lang }) => {
  const year = new Date().getFullYear();

  const goTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer"
      className="relative bg-black border-t border-white/10"
    >
      {/* Contact CTA section */}
      <section
        data-testid="contact-section"
        className="max-w-7xl mx-auto px-6 sm:px-8 py-24 sm:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-end"
      >
        <div className="lg:col-span-8">
          <p className="text-[10px] uppercase tracking-[0.4em] text-white/50 mb-6">
            — {t.contact.eyebrow} —
          </p>
          <h2
            data-testid="contact-title"
            className="heading-display text-4xl sm:text-5xl md:text-6xl mb-6 whitespace-pre-line"
          >
            {t.contact.title}
          </h2>
          <p className="text-white/55 text-base sm:text-lg max-w-md">{t.contact.sub}</p>
        </div>
        <div className="lg:col-span-4 flex lg:justify-end">
          <a
            data-testid="contact-whatsapp-cta"
            href={buildWhatsAppLink(
              lang === "fr"
                ? "Bonjour PRESTIGE KEY, j'aimerais discuter d'une demande."
                : "Hello PRESTIGE KEY, I would like to discuss a request."
            )}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-luxe"
            style={{ background: "#fff", color: "#050505", borderColor: "#fff" }}
          >
            {t.contact.cta}
            <ArrowUpRight size={14} />
          </a>
        </div>
      </section>

      {/* Footer body */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-12 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5 space-y-4">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Prestige Key" className="h-10 w-auto logo-3d" style={{ animation: "none" }} />
              <span className="heading-display tracking-[0.2em] uppercase text-base">
                Prestige Key
              </span>
            </div>
            <p className="text-sm text-white/55 max-w-sm">{t.footer.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-4">Menu</p>
            <ul className="space-y-2.5 text-sm">
              <li>
                <button data-testid="footer-link-about" onClick={() => goTo("about")} className="text-white/70 hover:text-white link-underline">
                  {t.footer.links.about}
                </button>
              </li>
              <li>
                <button data-testid="footer-link-services" onClick={() => goTo("services")} className="text-white/70 hover:text-white link-underline">
                  {t.footer.links.services}
                </button>
              </li>
              <li>
                <button data-testid="footer-link-steps" onClick={() => goTo("steps")} className="text-white/70 hover:text-white link-underline">
                  {t.footer.links.steps}
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-4">Social</p>
            <div className="flex items-center gap-3">
              <a
                data-testid="footer-instagram"
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="h-11 w-11 inline-flex items-center justify-center rounded-full border border-white/15 hover:bg-white hover:text-black transition-colors"
              >
                <Instagram size={18} strokeWidth={1.4} />
              </a>
              <a
                data-testid="footer-whatsapp"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="h-11 w-11 inline-flex items-center justify-center rounded-full border border-white/15 hover:bg-white hover:text-black transition-colors"
              >
                <MessageCircle size={18} strokeWidth={1.4} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] uppercase tracking-[0.28em] text-white/40">
            <span>© {year} Prestige Key — {t.footer.rights}</span>
            <span>Designed with restraint.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
